/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/DifficultySelectionModal',['pixi', 'absolute', 'lodash', 'MenuUI/MsftButton', 'MenuUI/MsftRectButton', 'MenuUI/ControlFocusManager',
	'absolute/stringmanager', 'util/NineSliceButton', 'util/DetailedButton',
	'Managers/ScaleManager', 'MenuUI/ChallengeFooter', 'Managers/TelemetryManager', 'util/SettingsManager'],

	function (PIXI, Absolute, _, MsftButton, MsftRectButton, ControlFocusManager, StringManager,
		NineSliceButton, DetailedButton, ScaleManager, ChallengeFooter,
		TelemetryManager, SettingsManager) {

		var DifficultySelectionModal = function (parent, game, config, footer, isRestart) {
			PIXI.DisplayObjectContainer.call(this);
			this.parentToAdd = parent;
			this.game = game;
			this.config = config;
			this.challengeFooter = footer;
			this.isRestart = isRestart;
			this.radioButtons = [];
			this.difficultySelected = 0;
			this.dropDownButtons = [];
			this.gameModeSelected = 0;
			this.dropDownButtonsGroup = new PIXI.DisplayObjectContainer();
			this.dropDownButton;
			this.toggleButton;
			this.toggleButtonCheck = false;

			this.initModal();
			parent.addChild(this);

			this.initBackground();
			this.initRibbon();
			this.initInfo();
			this.initOptions();
			this.initNavigationButtons();
			this.initToggleButton();
			this.initForceScaleSprite();
			ScaleManager.addElement(this, { scaleChangeSource: 'Full' });
		};

		var ColorConstants = {
			Klondike: { right: "#1b9ecb", left: "#48cffd" },
			Spider: { right: "#9757ce", left: "#d5a4ff" },
			FreeCell: { right: "#d62c29", left: "#ff7070" },
			Pyramid: { right: "#d98a01", left: "#fb9a00" },
			TriPeaks: { right: "#79b31b", left: "#8ac91d" }
		};

		DifficultySelectionModal.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		DifficultySelectionModal.prototype.initModal = function () {
			this.modal = new PIXI.Graphics();
			this.modal.beginFill(0x000000);
			this.modal.drawRect(0, 0, Absolute.Coords.x(10000), Absolute.Coords.y(10000));
			this.modal.alpha = 0.8;
			this.modal.interactive = true;
			this.bindModalInput();
			this.parentToAdd.addChild(this.modal);

			this.controlFocusManager = new ControlFocusManager();
		};

		DifficultySelectionModal.prototype.bindModalInput = function () {
			this.modal.mouseover = function (evt) {
			};
			this.modal.mouseout = function (evt) {
			};
			this.modal.mousedown = function (evt) {
			};
			this.modal.mouseup = function (evt) {
			};
			this.modal.touchstart = function (evt) {
			};
			this.modal.touchend = function (evt) {
			};
			this.modal.touchendoutside = function (evt) {
			};
		};

		DifficultySelectionModal.prototype.initBackground = function () {
			this.bodyGroup = new PIXI.DisplayObjectContainer();

			this.addChild(this.bodyGroup);
			var borderImage = new PIXI.Graphics();
			var backgroundImage = new PIXI.Graphics();
			this.bodyGroup.addChild(borderImage);
			this.bodyGroup.addChild(backgroundImage);

			const fontSize = (this.config.buttonHeight * 2 / 3);
			const dropdownButtonHeight = (this.config.gameModes.length > 1) ? this.config.buttonHeight * (3 / 2) : 0;


			this.config.height = this.config.padding * 2 +
				fontSize + this.config.buttonSpacing +
				dropdownButtonHeight + this.config.buttonSpacing +
				this.config.buttons.length * (this.config.buttonHeight + this.config.buttonSpacing);

			this.config.height += this.config.borderSize * 2;
			this.config.height += this.config.padding * 5;
			this.config.height += this.config.toggleButtonSize;
			this.config.height += this.config.ribbonHeight;
			this.config.height += 100; // Play button height

			borderImage.beginFill(this.config.borderColor);
			borderImage.drawRect(
				0, 0, Absolute.Coords.x(this.config.width), Absolute.Coords.y(this.config.height)
			);
			borderImage.endFill();

			backgroundImage.beginFill(this.config.backgroundColor);
			backgroundImage.drawRect(
				Absolute.Coords.x(this.config.borderSize),
				Absolute.Coords.y(this.config.borderSize),
				Absolute.Coords.x(this.config.width - this.config.borderSize * 2),
				Absolute.Coords.y(this.config.height - this.config.borderSize * 2)
			);
			backgroundImage.endFill();
		};

		DifficultySelectionModal.prototype.initOptions = function () {
			this.optionsGroup = new PIXI.DisplayObjectContainer();

			this.addChild(this.optionsGroup);

			const fontSize = (this.config.buttonHeight * 2 / 3);
			const dropdownButtonHeight = (this.config.gameModes.length > 1) ? this.config.buttonHeight * (3 / 2) : 0;

			const backgroundStartingHeight = (
				this.config.borderSize + this.config.ribbonHeight + this.config.padding * 2
			);
			const descriptionStartingHeight = (
				backgroundStartingHeight + this.config.buttonSpacing
			);
			const dropDownStartingHeight = (
				descriptionStartingHeight +
				fontSize + this.config.buttonSpacing
			);
			const optionButtonsStartingHeight = (
				dropDownStartingHeight +
				dropdownButtonHeight + this.config.buttonSpacing
			);
			const optionButtonsTotalHeight = (
				this.config.padding * 2 +
				fontSize + this.config.buttonSpacing +
				dropdownButtonHeight + this.config.buttonSpacing +
				this.config.buttons.length * (this.config.buttonHeight + this.config.buttonSpacing)
			);

			var optionsBackgroundImage = new PIXI.Graphics();
			this.optionsGroup.addChild(optionsBackgroundImage);

			optionsBackgroundImage.beginFill(0x032744);
			optionsBackgroundImage.drawRoundedRect(
				Absolute.Coords.x(this.config.borderSize + this.config.padding),
				Absolute.Coords.y(backgroundStartingHeight),
				Absolute.Coords.x(this.config.width - (this.config.borderSize + this.config.padding) * 2),
				Absolute.Coords.y(optionButtonsTotalHeight),
				15
			);
			optionsBackgroundImage.endFill();

			textStyle = {
				font: Absolute.ScreenMetrics.getResScale() * fontSize + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff'
			};

			optionDescription = new PIXI.Text(this.config.modalDescription, textStyle);
			this.optionsGroup.addChild(optionDescription);
			optionDescription.position.set(
				Absolute.Coords.x(this.config.width / 2),
				Absolute.Coords.y(descriptionStartingHeight)
			);
			optionDescription.anchor.set(.5, 0);

			textStyle = {
				font: Absolute.ScreenMetrics.getResScale() * fontSize / 2 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff'
			};

			optionDisclaimer = new PIXI.Text(this.config.modalDisclaimer, textStyle);
			this.optionsGroup.addChild(optionDisclaimer);
			optionDisclaimer.position.set(
				Absolute.Coords.x(this.config.width / 2),
				Absolute.Coords.y(
					backgroundStartingHeight + optionButtonsTotalHeight -
					(this.config.padding + this.config.buttonSpacing) / 2)
			);
			optionDisclaimer.anchor.set(.5, .5);

            this.initOptionsButtons(this.optionsGroup, optionButtonsStartingHeight);

			if (this.config.gameModes.length > 1) {
				var optionBackgroundImage = new PIXI.Graphics();
				optionBackgroundImage.beginFill(0x6989a1, 1);
				optionBackgroundImage.drawRect(
					Absolute.Coords.x(this.config.borderSize + this.config.padding * 2),
					Absolute.Coords.y(dropDownStartingHeight),
					Absolute.Coords.x(this.config.width - (this.config.borderSize + this.config.padding * 2) * 2),
					Absolute.Coords.y(this.config.buttonHeight * (3 / 2))
				);
				optionBackgroundImage.endFill();
				this.optionsGroup.addChild(optionBackgroundImage);

				var optionListBackgroundImage = new PIXI.Graphics();
				optionListBackgroundImage.beginFill(0x6989a1, 1);
				optionListBackgroundImage.drawRect(
					Absolute.Coords.x(this.config.borderSize + this.config.padding * 2),
					Absolute.Coords.y(dropDownStartingHeight + this.config.buttonHeight * (3 / 2)),
					Absolute.Coords.x(this.config.width - (this.config.borderSize + this.config.padding * 2) * 2),
					Absolute.Coords.y((this.config.buttonHeight * (3 / 2) - this.config.borderSize * 2) * this.config.gameModes.length + this.config.borderSize)
				);
				optionListBackgroundImage.endFill();
				this.dropDownButtonsGroup.addChild(optionListBackgroundImage);

				textStyle = {
					font: Absolute.ScreenMetrics.getResScale() * fontSize * (2 / 3) + "px Arial",
					fontFamily: 'segoe',
					fill: '#ffffff'
				};

				this.dropDownButton = this.addDropDownButton('Error: No Value', dropDownStartingHeight + this.config.borderSize, 0, true);

				this.createDropDown(this.dropDownButtonsGroup, dropDownStartingHeight + this.config.borderSize * 2);

				this.optionArrowBottomImage = new PIXI.Text('v', textStyle);
				this.optionArrowBottomImage.position.set(
					Absolute.Coords.x(this.config.width - (this.config.borderSize * 2 + this.config.padding * 3)),
					Absolute.Coords.y(dropDownStartingHeight + dropdownButtonHeight / 2)
				);
				this.optionArrowBottomImage.anchor.set(.5, .5);
			}
			
			if (this.config.gameModes.length > 1) {
				this.optionsGroup.addChild(this.dropDownButton);
				this.optionsGroup.addChild(this.dropDownButtonsGroup);
				this.optionsGroup.addChild(this.optionArrowBottomImage);
			}
		};

		DifficultySelectionModal.prototype.initOptionsButtons = function (optionsGroup, optionButtonsStartingHeight) {
			var buttonPositionCount = 0;
			for (var i = 0; i < this.config.buttons.length; i++) {
				const optionButton = this.addOptionButton(this.config.buttons[i].name, optionButtonsStartingHeight, buttonPositionCount);
				optionsGroup.addChild(optionButton);
				this.radioButtons.push(optionButton);
				buttonPositionCount++;
			}

            const currentDifficulty = SettingsManager.getSetting(this.config.gameName.toLowerCase(), 'difficulty');
			this.selectCurrentDifficulty(currentDifficulty);
		};

		DifficultySelectionModal.prototype.selectCurrentDifficulty = function (currentDifficulty) {
            for (var i = 0; i < this.config.buttons.length; i++) {
				if (this.config.buttons[i].value === currentDifficulty) {
					this.radioButtons[i].select();
					this.difficultySelected = i;
				}
			}
		}

		DifficultySelectionModal.prototype.createDropDown = function (optionsGroup, optionButtonsStartingHeight) {
            var buttonPositionCount = 1;
            for (var i = 0; i < this.config.gameModes.length; i++) {
				const optionButton = this.addDropDownButton(this.config.gameModes[i].name, optionButtonsStartingHeight, buttonPositionCount, false);
				optionsGroup.addChild(optionButton);
				this.dropDownButtons.push(optionButton);
				buttonPositionCount++;
			}

			if (this.config.gameName.toLowerCase() === 'klondike') {
				const scoringType = SettingsManager.getSetting(this.config.gameName.toLowerCase(), 'scoringType');
				const cardsPerDraw = SettingsManager.getSetting(this.config.gameName.toLowerCase(), 'cardsPerDraw');
				this.selectKlondikeGameMode(scoringType, cardsPerDraw);
			}
			else if (this.config.gameName.toLowerCase() === 'spider') {
				const suits = SettingsManager.getSetting(this.config.gameName.toLowerCase(), 'suits');
				this.selectSpiderGameMode(suits);
			}            

			this.dropDownButtonsGroup.visible = false;
		};

		DifficultySelectionModal.prototype.selectKlondikeGameMode = function (scoringType, cardsPerDraw) {
            for (var i = 0; i < this.config.gameModes.length; i++) {
				if (this.config.gameModes[i].scoringType === scoringType &&
					this.config.gameModes[i].cardsPerDraw === cardsPerDraw) {
					this.selectDropDownButton(this.dropDownButtons[i], i);
				}
			}
		}

		DifficultySelectionModal.prototype.selectSpiderGameMode = function (suits) {
            for (var i = 0; i < this.config.gameModes.length; i++) {
				console.log(this.config.gameModes[i].suits);
				if (this.config.gameModes[i].suits === suits) {
					this.selectDropDownButton(this.dropDownButtons[i], i);
				}
			}
		}

		DifficultySelectionModal.prototype.addDropDownButton = function (buttonName, startingHeight, buttonPositionCount, display) {
			var buttonConfig = {
				primaryColor: parseInt(ColorConstants[this.config.gameName].right.replace('#', ''), 16),
				backgroundColor: 0x021729,
				height: this.config.buttonHeight * (3 / 2) - this.config.borderSize * 2,
				width: this.config.width - this.config.borderSize * 4 - this.config.padding * 4,
				positionX: (this.config.borderSize + this.config.padding) * 2,
				positionY: startingHeight + (this.config.buttonHeight * (3 / 2) - this.config.borderSize * 2) * buttonPositionCount
			};

			const fontSize = (buttonConfig.height / 3);
			textStyle = {
				font: Absolute.ScreenMetrics.getResScale() * fontSize + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff'
			};

			const dropDownButtonLabel = new PIXI.Text(buttonName, textStyle);
			dropDownButtonLabel.position.set(
				Absolute.Coords.x(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height / 2 + 2)
			);
			dropDownButtonLabel.anchor.set(0, .5);

			var upTexture = this.createDropDownButtonUp(buttonConfig, dropDownButtonLabel);
			var overTexture = this.createDropDownButtonOver(buttonConfig, dropDownButtonLabel);
			var downTexture = this.createDropDownButtonDown(buttonConfig, dropDownButtonLabel);
			var selectedTexture = this.createDropDownButtonSelected(buttonConfig, dropDownButtonLabel);
			// var disabledTexture = this.createDropDownButtonDisabled(buttonConfig, optionButtonLabel);

			var dropDownButton = new DetailedButton(
				upTexture,
				overTexture,
				downTexture,
				selectedTexture,
				downTexture
            );

            dropDownButton.isDropDownButton = true;

			dropDownButton.position.set(
				Absolute.Coords.x(buttonConfig.positionX),
				Absolute.Coords.y(buttonConfig.positionY)
			);
			dropDownButton.anchor.set(0, 0);

			if (display) {
				dropDownButton.onClick.add(function () {
					this.dropDownButtonsGroup.visible = !this.dropDownButtonsGroup.visible;
				}.bind(this));
			} else {
				dropDownButton.onClick.add(function () {
                    for (var i = 0; i < this.dropDownButtons.length; i++) {
						this.dropDownButtons[i].deselect();
					}

					this.selectDropDownButton(this.dropDownButtons[buttonPositionCount - 1], buttonPositionCount - 1);

					this.dropDownButtonsGroup.visible = false;
				}.bind(this));
			}

			this.controlFocusManager.addControl(dropDownButton, true, 'DropDownButtons', buttonPositionCount);

			return dropDownButton;
		};


		DifficultySelectionModal.prototype.selectDropDownButton = function (selectedDropDownButton, gameModeSelected) {
			selectedDropDownButton.select();
			this.gameModeSelected = gameModeSelected;

			this.dropDownButton.upTexture = selectedDropDownButton.upTexture;
			this.dropDownButton.downTexture = selectedDropDownButton.downTexture;
			this.dropDownButton.overTexture = selectedDropDownButton.overTexture;
			this.dropDownButton.selectTexture = selectedDropDownButton.selectTexture;
			this.dropDownButton.disabledTexture = selectedDropDownButton.disabledTexture;
			this.dropDownButton.setTexture(this.dropDownButton.upTexture);

			this.ableOptions(this.config.gameModes[gameModeSelected].disables);
		}

		DifficultySelectionModal.prototype.ableOptions = function (disables) {
            for (var i = 0; i < this.radioButtons.length; i++) {
				this.radioButtons[i].enable();
                for (var j = 0; j < disables.length; j++) {
					 // If this button is on the diable list disable it
					if (this.config.buttons[i].value === disables[j]) {
						 // If currently selected, select the next value before disabling.
						if (this.difficultySelected === i) {
							this.radioButtons[i].deselect();

							this.radioButtons[i + 1].select();
							this.difficultySelected = i + 1;
						}
						this.radioButtons[i].disable();
					}
				}
			}
		}

		DifficultySelectionModal.prototype.addOptionButton = function (buttonName, startingHeight, buttonPositionCount) {
			var buttonConfig = {
				primaryColor: parseInt(ColorConstants[this.config.gameName].right.replace('#', ''), 16),
				backgroundColor: 0x021729,
				height: this.config.buttonHeight,
				spacing: this.config.buttonSpacing,
				width: this.config.width - this.config.borderSize * 2 - this.config.padding * 4,
				positionX: this.config.borderSize + this.config.padding * 2,
				positionY: startingHeight + (this.config.buttonHeight + this.config.buttonSpacing) * buttonPositionCount
			};

			const fontSize = (buttonConfig.height / 2);
			textStyle = {
				font: Absolute.ScreenMetrics.getResScale() * fontSize + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff'
			};

			optionButtonLabel = new PIXI.Text(buttonName, textStyle);
			optionButtonLabel.position.set(
				Absolute.Coords.x(buttonConfig.height + buttonConfig.height / 3),
				Absolute.Coords.y((buttonConfig.height - fontSize) / 2 - 1)
			);

			var upTexture = this.createOptionButtonUp(buttonConfig, optionButtonLabel);
			var overTexture = this.createOptionButtonOver(buttonConfig, optionButtonLabel);
			var downTexture = this.createOptionButtonDown(buttonConfig, optionButtonLabel);
			var selectedTexture = this.createOptionButtonSelected(buttonConfig, optionButtonLabel);
			var disabledTexture = this.createOptionButtonDisabled(buttonConfig, optionButtonLabel);

			var optionButton = new DetailedButton(
				upTexture,
				overTexture,
				downTexture,
				selectedTexture,
				disabledTexture
			);

			optionButton.position.set(
				Absolute.Coords.x(buttonConfig.positionX),
				Absolute.Coords.y(buttonConfig.positionY)
			);

			optionButton.onClick.add(function () {
				for (var i = 0; i < this.radioButtons.length; i++) {
					this.radioButtons[i].deselect();
				}
				this.radioButtons[buttonPositionCount].select();
				this.difficultySelected = buttonPositionCount;
			}.bind(this));

			this.controlFocusManager.addControl(optionButton, false, 'OptionButtons', buttonPositionCount);

			return optionButton;
		};


		DifficultySelectionModal.prototype.initRibbon = function () {
			this.ribbonGroup = new PIXI.DisplayObjectContainer();
			var gameName = this.config.gameName;
			var rightHex = ColorConstants[gameName].right,
				leftHex = ColorConstants[gameName].left;
			const hexHeight = this.config.borderSize + this.config.padding + this.config.ribbonHeight;
			this.addChild(this.ribbonGroup);
			var leftCorner = new PIXI.Sprite.fromFrame("challenge_start/banner_" + gameName + "_left_corner.png"),
				rightCorner = new PIXI.Sprite.fromFrame("challenge_start/banner_" + gameName + "_right_corner.png");
			this.ribbonGroup.addChild(leftCorner);
			this.ribbonGroup.addChild(rightCorner);

			leftCorner.position.set(Absolute.Coords.x(-19), Absolute.Coords.y(hexHeight));
			rightCorner.position.set(Absolute.Coords.x(this.config.width), Absolute.Coords.y(hexHeight));

			var ribbonGraphics = new PIXI.Graphics();
			this.ribbonGroup.addChild(ribbonGraphics);

			ribbonGraphics.beginFill(parseInt(rightHex.replace('#', ''), 16), 1);
			ribbonGraphics.drawRect(Absolute.Coords.x(-19), Absolute.Coords.y(this.config.borderSize + this.config.padding),
				Absolute.Coords.x(19 * 2 + this.config.width), Absolute.Coords.y(this.config.ribbonHeight));
			ribbonGraphics.endFill();

			ribbonGraphics.beginFill(0x000000, .3);
			ribbonGraphics.drawRect(Absolute.Coords.x(-19), Absolute.Coords.y(hexHeight),
				Absolute.Coords.x(19 * 2 + this.config.width), Absolute.Coords.y(4));
			ribbonGraphics.endFill();

			this.ribbonLeftCorner = leftCorner;
			this.ribbonRightCorner = rightCorner;
		};

		DifficultySelectionModal.prototype.initInfo = function () {
			var gameLabel, gameIcon, config, textStyle;
			const textHeight = this.config.borderSize + this.config.padding + this.config.ribbonHeight / 2;

			config = this.config;
			textStyle = {
				font: Absolute.ScreenMetrics.getResScale() * 31 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff'
			};
			gameLabel = new PIXI.Text(config.gameNameText, textStyle);

			gameIcon = new PIXI.Sprite.fromFrame('icon_' + (config.gameName).toLowerCase() + '_topUI.png');

			this.ribbonGroup.addChild(gameLabel);
			this.ribbonGroup.addChild(gameIcon);

			gameLabel.position.set(Absolute.Coords.x(80), Absolute.Coords.y(textHeight));
			gameLabel.anchor.set(0, .5);
			gameIcon.position.set(Absolute.Coords.x(30), Absolute.Coords.y(textHeight - 3)); // Image is a little hard to center
			gameIcon.anchor.set(.5, .5);
		};

		DifficultySelectionModal.prototype.initNavigationButtons = function () {
			var labelOptions = {
				font: Absolute.ScreenMetrics.getResScale() * 31 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff',
				align: 'left',
				anchor: {
					x: 0.5,
					y: 0.5
				},
				x: Absolute.Coords.x(0),
				y: Absolute.Coords.y(3)
			};
			var buttonSize = {
				width: 270,
				height: 100
			}

			this.closeButton = new NineSliceButton(
				'warning_dialogues/popup_button_Cancel_click.png',
				'warning_dialogues/popup_button_Cancel_over.png', 'warning_dialogues/popup_button_Cancel.png',
				Absolute.Coords.x(buttonSize.width), Absolute.Coords.y(buttonSize.height), 25, 25, 25, 25, Absolute.StringManager('buttons.cancel'), labelOptions);
			this.playButton = new NineSliceButton(
				'warning_dialogues/popup_button_Play_click.png',
				'warning_dialogues/popup_button_Play_over.png', 'warning_dialogues/popup_button_Play.png',
				Absolute.Coords.x(buttonSize.width), Absolute.Coords.y(buttonSize.height), 25, 25, 25, 25, Absolute.StringManager('buttons.play'), labelOptions);
			this.bodyGroup.addChild(this.closeButton);
			this.bodyGroup.addChild(this.playButton);

			this.closeButton.position.set(
				Absolute.Coords.x(this.config.padding + this.config.borderSize + buttonSize.width / 2),
				Absolute.Coords.y(this.config.height - (this.config.padding * 2 + this.config.borderSize + buttonSize.height / 2 + this.config.toggleButtonSize)));
			this.playButton.position.set(
				Absolute.Coords.x(this.config.width - (this.config.padding + this.config.borderSize + buttonSize.width / 2)),
				Absolute.Coords.y(this.config.height - (this.config.padding * 2 + this.config.borderSize + buttonSize.height / 2 + this.config.toggleButtonSize)));
			this.closeButton.anchor.set(.5, .5);
			this.playButton.anchor.set(.5, .5);

			this.playButton.onClick.add(function () {
				// Deal new game
                TelemetryManager.closedNewDealMenu(true);
				Absolute.AudioManager.playSound('button');

				SettingsManager.setSetting(this.config.gameName.toLowerCase(), 'showDifficulty', !this.toggleButtonCheck); // Opposite

				SettingsManager.setSetting(this.config.gameName.toLowerCase(), 'difficulty', this.config.buttons[this.difficultySelected].value);
				this.game.solitaire.Authority.CardSupply.Options.DIFFICULTY = this.config.buttons[this.difficultySelected].value;

				if (this.config.gameName.toLowerCase() === 'klondike') {
					SettingsManager.setSetting(this.config.gameName.toLowerCase(), 'scoringType', this.config.gameModes[this.gameModeSelected].scoringType);
					SettingsManager.setSetting(this.config.gameName.toLowerCase(), 'cardsPerDraw', this.config.gameModes[this.gameModeSelected].cardsPerDraw);
					this.game.solitaire.Authority.CardSupply.Options.DRAW = this.config.gameModes[this.gameModeSelected].cardsPerDraw;
					this.game.solitaire.Authority.CardSupply.Options.SCORING = this.config.gameModes[this.gameModeSelected].scoringType;
				}
				else if (this.config.gameName.toLowerCase() === 'spider') {
					SettingsManager.setSetting(this.config.gameName.toLowerCase(), 'suits', this.config.gameModes[this.gameModeSelected].suits);
					this.game.solitaire.Authority.CardSupply.NumSuits = this.config.gameModes[this.gameModeSelected].suits;
				}

				// this.game.gameScreenUI.confirmNewDeal();
				this.game.gameScreenUI.updateLayout();
				this.game.solitaire.DealNewGame();
				this.game.solitaire.Authority.CardSupply.IsWaitingForAds = false;
				this.playButton.interactive = false;
				this.closeButton.interactive = false;
				this.playButton.alpha = .5;
				this.closeButton.alpha = .5;
				// this.doAnimation();
				this.destroy();
			}.bind(this));
			this.closeButton.onClick.add(function () {
				Absolute.AudioManager.playSound('button');
				// this.game.navBack();
                TelemetryManager.closedNewDealMenu(false);
				this.destroy();
			}.bind(this));

			this.controlFocusManager.addControl(this.closeButton, false, 'ActionButtons', 0);
			this.controlFocusManager.addControl(this.playButton, false, 'ActionButtons', 1);
		};

		DifficultySelectionModal.prototype.initToggleButton = function () {

			var buttonConfig = {
				primaryColor: parseInt(ColorConstants[this.config.gameName].right.replace('#', ''), 16),
				backgroundColor: this.config.backgroundColor,
				borderSize: this.config.borderSize / 2,
				height: this.config.toggleButtonSize,
				width: this.config.toggleButtonSize,
				positionX: this.config.borderSize + this.config.padding,
				positionY: this.config.height - (this.config.padding + this.config.borderSize + this.config.toggleButtonSize)
			};

            var textStyle = {
				font: Absolute.ScreenMetrics.getResScale() * buttonConfig.height + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff'
			};

			this.toggleButtonCheckImage = new PIXI.Text('x', textStyle); // Make text first so i can reference it, set visuals later so it renders on top.

			var upTexture = this.createToggleButtonUp(buttonConfig);
			var overTexture = this.createToggleButtonOver(buttonConfig);
			var downTexture = this.createToggleButtonDown(buttonConfig);
			var selectedTexture = this.createToggleButtonSelected(buttonConfig);
			var disabledTexture = this.createToggleButtonDisabled(buttonConfig);

			this.toggleButton = new DetailedButton(
				upTexture,
				overTexture,
				downTexture,
				selectedTexture,
				disabledTexture
			);

			this.toggleButton.position.set(
				Absolute.Coords.x(buttonConfig.positionX),
				Absolute.Coords.y(buttonConfig.positionY)
			);

			this.toggleButton.onClick.add(function () {
				if (this.toggleButtonCheck) {
					this.toggleButtonCheckImage.visible = false;
					this.toggleButtonCheck = false;
				} else {
					this.toggleButtonCheckImage.visible = true;
					this.toggleButtonCheck = true;
				}
			}.bind(this));

			this.optionsGroup.addChild(this.toggleButton);

			this.optionsGroup.addChild(this.toggleButtonCheckImage);
			this.toggleButtonCheckImage.position.set(
				Absolute.Coords.x(buttonConfig.positionX + buttonConfig.width / 2),
				Absolute.Coords.y(buttonConfig.positionY + buttonConfig.height / 2)
			);
			this.toggleButtonCheckImage.anchor.set(.5, .5);
			this.optionsGroup.addChild(this.toggleButtonCheckImage);

			this.toggleButtonCheckImage.visible = false;

			textStyle = {
				font: Absolute.ScreenMetrics.getResScale() * buttonConfig.height * 2 / 3 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff'
			};

			toggleLabel = new PIXI.Text(Absolute.StringManager('solvable.alwaysRememberSelection'), textStyle);
			this.optionsGroup.addChild(toggleLabel);
			toggleLabel.position.set(
				Absolute.Coords.x(buttonConfig.positionX + buttonConfig.width * 1.5),
				Absolute.Coords.y(buttonConfig.positionY + buttonConfig.height / 2 + 2)
			);
			toggleLabel.anchor.set(0, .5);

			this.controlFocusManager.addControl(this.toggleButton, false, 'ToggleButton', 0);
		}
		
		DifficultySelectionModal.prototype.destroy = function () {
			ScaleManager.removeElement(this);
			this.parentToAdd.removeChild(this);
			this.parentToAdd.removeChild(this.modal);
            this.game.gameScreenUI.handleModalClosed();
		};

		DifficultySelectionModal.prototype.initForceScaleSprite = function () {
			this.forceScaleSprite = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
			this.forceOffsetX = Absolute.Coords.x(this.config.offsetX + 56); // Not sure why it's 56 but that perfectly centers the modal
			this.forceOffsetY = Absolute.Coords.y(this.config.offsetY);
			this.forceScaleSprite.width = Absolute.Coords.x(this.config.width);
			this.forceScaleSprite.height = Absolute.Coords.y(this.config.height);
			this.forceScaleSprite.alpha = 0;
			this.addChild(this.forceScaleSprite);
		};

		DifficultySelectionModal.prototype.handleResize = function () {
			if (this.parent) this.updateTransform();
			var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
			this.scale.set(1, 1);
			var initialWidth = this.width, initialHeight = this.height;
			this.scale.set(oldScaleX, oldScaleY);
			var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
				screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
				roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
			this.width = initialWidth * screenScaleX;
			this.height = initialHeight * screenScaleY;
			var realWidth = this.width / screenScaleX, realHeight = this.height / screenScaleY;
			var widthToShow = initialWidth, heightToShow = initialHeight;
			var tookCare = false;
			if (realWidth > roomWidth) {
				this.width = Absolute.Coords.x(1920);
				var delta = roomWidth / widthToShow;
				this.height = ((initialHeight * screenScaleY) * delta);
				if ((this.height / screenScaleY) > roomHeight) {
					this.height = Absolute.Coords.y(1080);
					var delta = roomHeight / heightToShow;
					this.width = ((initialWidth * screenScaleX) * delta);
				}
				tookCare = true;
			}
			if (!tookCare && (realHeight > roomHeight)) {
				this.height = Absolute.Coords.y(1080);
				var delta = roomHeight / heightToShow;
				this.width = ((initialWidth * screenScaleX) * delta);
				if ((this.width / screenScaleX) > roomWidth) {
					this.width = Absolute.Coords.x(1920);
					var delta = roomWidth / widthToShow;
					this.height = ((initialHeight * screenScaleY) * delta);
				}
			}
			this.x = (Absolute.Coords.x(1920) / 2) - (this.width / 2) + this.forceOffsetX;
			this.y = (Absolute.Coords.y(1080) / 2) - (this.height / 2) + this.forceOffsetY;
		};

		DifficultySelectionModal.prototype.handleCommand = function (command) {
			switch (command) {
				case 'Tab': {
					if (this.controlFocusManager.currentFocusGroup === 'ActionButtons') {
						this.controlFocusManager.nextFocusGroup();
					} else {
						this.controlFocusManager.nextFocusGroup();
					}
					break;
				}
				case 'Right': {
					if (this.controlFocusManager.currentFocusGroup === 'ActionButtons') {
						this.controlFocusManager.focusNextControl(1);
					} else {
						this.controlFocusManager.nextFocusGroup();
					}
					break;
				}
				case 'Left':
					if (this.controlFocusManager.currentFocusGroup === 'ActionButtons') {
						this.controlFocusManager.focusNextControl(-1);
					} else {
						this.controlFocusManager.prevFocusGroup();
					}
					break;
				case 'Up': {
					if (this.controlFocusManager.currentFocusGroup === 'ActionButtons' ||
						this.controlFocusManager.currentFocusGroup === 'ToggleButton') {
						this.controlFocusManager.prevFocusGroup();
					} else {
						this.controlFocusManager.focusNextControl(-1);
					}
					break;
				}
				case 'Down': {
					if (this.controlFocusManager.currentFocusGroup === 'ActionButtons' ||
						this.controlFocusManager.currentFocusGroup === 'ToggleButton') {
						this.controlFocusManager.nextFocusGroup();
					} else {
						this.controlFocusManager.focusNextControl(1);
					}
					break;
				}
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					return;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
				// I feel we should have an escape case, to close modals.
			}

			if (this.controlFocusManager.currentFocusGroup === 'DropDownButtons') {
				this.dropDownButtonsGroup.visible = true;
			} else {
				this.dropDownButtonsGroup.visible = false;
			}
		};

		// Button Images ---------------------------------------------------------------
		// TODO These can all be moved elsewhere for reuseability

		DifficultySelectionModal.prototype.createOptionButtonUp = function (buttonConfig, optionButtonLabel) {
			var optionButtonUp = new PIXI.DisplayObjectContainer();

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.backgroundColor, 1);
			optionBackgroundImage.drawRoundedRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height),
				Absolute.Coords.y((buttonConfig.height - 2) / 2)
			);
			optionBackgroundImage.endFill();
			optionButtonUp.addChild(optionBackgroundImage);

			var optionSelectImage = new PIXI.Graphics();
			optionSelectImage.lineStyle(3, buttonConfig.primaryColor);
			optionSelectImage.drawCircle(
				Absolute.Coords.x(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height * (7 / 10) / 2)
			);
			optionSelectImage.endFill();
			optionButtonUp.addChild(optionSelectImage);

			optionButtonUp.addChild(optionButtonLabel);

			const texture = optionButtonUp.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createOptionButtonOver = function (buttonConfig, optionButtonLabel) {
			var optionButtonOver = new PIXI.DisplayObjectContainer();

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.primaryColor, 0.5);
			optionBackgroundImage.drawRoundedRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(this.config.width - (this.config.borderSize + this.config.padding) * 2 * 2),
				Absolute.Coords.y(buttonConfig.height),
				Absolute.Coords.y((buttonConfig.height - 2) / 2)
			);
			optionBackgroundImage.endFill();
			optionButtonOver.addChild(optionBackgroundImage);

			var optionSelectImage = new PIXI.Graphics();
			optionSelectImage.lineStyle(3, buttonConfig.primaryColor);
			optionSelectImage.drawCircle(
				Absolute.Coords.x(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height * (7 / 10) / 2)
			);
			optionSelectImage.endFill();
			optionButtonOver.addChild(optionSelectImage);

			optionButtonOver.addChild(optionButtonLabel);

			const texture = optionButtonOver.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createOptionButtonDown = function (buttonConfig, optionButtonLabel) {
			var optionButtonDown = new PIXI.DisplayObjectContainer();

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.primaryColor, 0.3);
			optionBackgroundImage.drawRoundedRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(this.config.width - (this.config.borderSize + this.config.padding) * 2 * 2),
				Absolute.Coords.y(buttonConfig.height),
				Absolute.Coords.y((buttonConfig.height - 2) / 2)
			);
			optionBackgroundImage.endFill();
			optionButtonDown.addChild(optionBackgroundImage);

			var optionSelectImage = new PIXI.Graphics();
			optionSelectImage.lineStyle(3, buttonConfig.primaryColor);
			optionSelectImage.drawCircle(
				Absolute.Coords.x(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height * (7 / 10) / 2)
			);
			optionSelectImage.endFill();
			optionButtonDown.addChild(optionSelectImage);

			optionButtonDown.addChild(optionButtonLabel);

			const texture = optionButtonDown.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createOptionButtonSelected = function (buttonConfig, optionButtonLabel) {
			var optionButtonSelected = new PIXI.DisplayObjectContainer();

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.primaryColor, 1);
			optionBackgroundImage.drawRoundedRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(this.config.width - (this.config.borderSize + this.config.padding) * 2 * 2),
				Absolute.Coords.y(buttonConfig.height),
				Absolute.Coords.y((buttonConfig.height - 2) / 2)
			);
			optionBackgroundImage.endFill();
			optionButtonSelected.addChild(optionBackgroundImage);

			var optionSelectImage = new PIXI.Graphics();
			optionSelectImage.lineStyle(3, 0xffffff);
			optionSelectImage.drawCircle(
				Absolute.Coords.x(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height * (7 / 10) / 2)
			);
			optionSelectImage.endFill();
			optionButtonSelected.addChild(optionSelectImage);

			var optionSelectImageCenter = new PIXI.Graphics();
			optionSelectImageCenter.beginFill(0xffffff, 1);
			optionSelectImageCenter.drawCircle(
				Absolute.Coords.x(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height * (5 / 10) / 2)
			);
			optionSelectImageCenter.endFill();
			optionButtonSelected.addChild(optionSelectImageCenter);

			optionButtonSelected.addChild(optionButtonLabel);

			const texture = optionButtonSelected.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createOptionButtonDisabled = function (buttonConfig, optionButtonLabel) {
			var optionButtonUp = new PIXI.DisplayObjectContainer();

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.backgroundColor, 1);
			optionBackgroundImage.drawRoundedRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height),
				Absolute.Coords.y((buttonConfig.height - 2) / 2)
			);
			optionBackgroundImage.endFill();
			optionButtonUp.addChild(optionBackgroundImage);

			var optionSelectImage = new PIXI.Graphics();
			optionSelectImage.lineStyle(3, buttonConfig.primaryColor);
			optionSelectImage.drawCircle(
				Absolute.Coords.x(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height / 2),
				Absolute.Coords.y(buttonConfig.height * (7 / 10) / 2)
			);
			optionSelectImage.endFill();
			optionButtonUp.addChild(optionSelectImage);

			optionButtonUp.addChild(optionButtonLabel);

			var optionMaskImage = new PIXI.Graphics();
			optionMaskImage.beginFill(0x000000, .5);
			optionMaskImage.drawRoundedRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height),
				Absolute.Coords.y((buttonConfig.height - 2) / 2)
			);
			optionMaskImage.endFill();
			optionButtonUp.addChild(optionMaskImage);

			const texture = optionButtonUp.generateTexture();
			return texture;
		}


		DifficultySelectionModal.prototype.createDropDownButtonUp = function (buttonConfig, optionButtonLabel) {
			var optionButtonUp = new PIXI.DisplayObjectContainer();

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.backgroundColor, 1);
			optionBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			optionBackgroundImage.endFill();
			optionButtonUp.addChild(optionBackgroundImage);

			optionButtonUp.addChild(optionButtonLabel);

			const texture = optionButtonUp.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createDropDownButtonOver = function (buttonConfig, optionButtonLabel) {
			var optionButtonUp = new PIXI.DisplayObjectContainer();

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.backgroundColor, 1);
			optionBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			optionBackgroundImage.endFill();
			optionButtonUp.addChild(optionBackgroundImage);

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(0xffffff, .2);
			optionBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			optionBackgroundImage.endFill();
			optionButtonUp.addChild(optionBackgroundImage);

			optionButtonUp.addChild(optionButtonLabel);

			const texture = optionButtonUp.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createDropDownButtonDown = function (buttonConfig, optionButtonLabel) {
			var optionButtonUp = new PIXI.DisplayObjectContainer();

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.backgroundColor, 1);
			optionBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			optionBackgroundImage.endFill();
			optionButtonUp.addChild(optionBackgroundImage);

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(0xffffff, .1);
			optionBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			optionBackgroundImage.endFill();
			optionButtonUp.addChild(optionBackgroundImage);

			optionButtonUp.addChild(optionButtonLabel);

			const texture = optionButtonUp.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createDropDownButtonSelected = function (buttonConfig, optionButtonLabel) {
			var optionButtonUp = new PIXI.DisplayObjectContainer();

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.backgroundColor, 1);
			optionBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			optionBackgroundImage.endFill();
			optionButtonUp.addChild(optionBackgroundImage);

			var optionBackgroundImage = new PIXI.Graphics();
			optionBackgroundImage.beginFill(buttonConfig.primaryColor, .5);
			optionBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			optionBackgroundImage.endFill();
			optionButtonUp.addChild(optionBackgroundImage);

			optionButtonUp.addChild(optionButtonLabel);

			const texture = optionButtonUp.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createToggleButtonUp = function (buttonConfig) {
			var toggleButtonUp = new PIXI.DisplayObjectContainer();

			var toggleBackgroundImage = new PIXI.Graphics();
			toggleBackgroundImage.beginFill(0xffffff, 1);
			toggleBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			toggleBackgroundImage.endFill();
			toggleButtonUp.addChild(toggleBackgroundImage);

			var toggleCenterImage = new PIXI.Graphics();
			toggleCenterImage.beginFill(buttonConfig.backgroundColor, .8);
			toggleCenterImage.drawRect(
				Absolute.Coords.x(buttonConfig.borderSize),
				Absolute.Coords.y(buttonConfig.borderSize),
				Absolute.Coords.x(buttonConfig.width - buttonConfig.borderSize * 2),
				Absolute.Coords.y(buttonConfig.height - buttonConfig.borderSize * 2)
			);
			toggleCenterImage.endFill();
			toggleButtonUp.addChild(toggleCenterImage);

			const texture = toggleButtonUp.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createToggleButtonOver = function (buttonConfig) {
			var toggleButtonUp = new PIXI.DisplayObjectContainer();

			var toggleBackgroundImage = new PIXI.Graphics();
			toggleBackgroundImage.beginFill(0xffffff, 1);
			toggleBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			toggleBackgroundImage.endFill();
			toggleButtonUp.addChild(toggleBackgroundImage);

			var toggleCenterImage = new PIXI.Graphics();
			toggleCenterImage.beginFill(buttonConfig.backgroundColor, .5);
			toggleCenterImage.drawRect(
				Absolute.Coords.x(buttonConfig.borderSize),
				Absolute.Coords.y(buttonConfig.borderSize),
				Absolute.Coords.x(buttonConfig.width - buttonConfig.borderSize * 2),
				Absolute.Coords.y(buttonConfig.height - buttonConfig.borderSize * 2)
			);
			toggleCenterImage.endFill();
			toggleButtonUp.addChild(toggleCenterImage);

			const texture = toggleButtonUp.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createToggleButtonDown = function (buttonConfig) {
			var toggleButtonUp = new PIXI.DisplayObjectContainer();

			var toggleBackgroundImage = new PIXI.Graphics();
			toggleBackgroundImage.beginFill(0xffffff, 1);
			toggleBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			toggleBackgroundImage.endFill();
			toggleButtonUp.addChild(toggleBackgroundImage);

			var toggleCenterImage = new PIXI.Graphics();
			toggleCenterImage.beginFill(buttonConfig.backgroundColor, .3);
			toggleCenterImage.drawRect(
				Absolute.Coords.x(buttonConfig.borderSize),
				Absolute.Coords.y(buttonConfig.borderSize),
				Absolute.Coords.x(buttonConfig.width - buttonConfig.borderSize * 2),
				Absolute.Coords.y(buttonConfig.height - buttonConfig.borderSize * 2)
			);
			toggleCenterImage.endFill();
			toggleButtonUp.addChild(toggleCenterImage);

			const texture = toggleButtonUp.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createToggleButtonSelected = function (buttonConfig) {
			var toggleButtonUp = new PIXI.DisplayObjectContainer();

			var toggleBackgroundImage = new PIXI.Graphics();
			toggleBackgroundImage.beginFill(0xffffff, 1);
			toggleBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			toggleBackgroundImage.endFill();
			toggleButtonUp.addChild(toggleBackgroundImage);

			var toggleCenterImage = new PIXI.Graphics();
			toggleCenterImage.beginFill(buttonConfig.backgroundColor, 1);
			toggleCenterImage.drawRect(
				Absolute.Coords.x(buttonConfig.borderSize),
				Absolute.Coords.y(buttonConfig.borderSize),
				Absolute.Coords.x(buttonConfig.width - buttonConfig.borderSize * 2),
				Absolute.Coords.y(buttonConfig.height - buttonConfig.borderSize * 2)
			);
			toggleCenterImage.endFill();
			toggleButtonUp.addChild(toggleCenterImage);

			const texture = toggleButtonUp.generateTexture();
			return texture;
		}

		DifficultySelectionModal.prototype.createToggleButtonDisabled = function (buttonConfig) {
			var toggleButtonUp = new PIXI.DisplayObjectContainer();

			var toggleBackgroundImage = new PIXI.Graphics();
			toggleBackgroundImage.beginFill(0xffffff, 1);
			toggleBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			toggleBackgroundImage.endFill();
			toggleButtonUp.addChild(toggleBackgroundImage);

			var toggleCenterImage = new PIXI.Graphics();
			toggleCenterImage.beginFill(buttonConfig.backgroundColor, 1);
			toggleCenterImage.drawRect(
				Absolute.Coords.x(buttonConfig.borderSize),
				Absolute.Coords.y(buttonConfig.borderSize),
				Absolute.Coords.x(buttonConfig.width - buttonConfig.borderSize * 2),
				Absolute.Coords.y(buttonConfig.height - buttonConfig.borderSize * 2)
			);
			toggleCenterImage.endFill();
			toggleButtonUp.addChild(toggleCenterImage);

			var toggleBackgroundImage = new PIXI.Graphics();
			toggleBackgroundImage.beginFill(0x000000, .5);
			toggleBackgroundImage.drawRect(
				Absolute.Coords.x(),
				Absolute.Coords.y(),
				Absolute.Coords.x(buttonConfig.width),
				Absolute.Coords.y(buttonConfig.height)
			);
			toggleBackgroundImage.endFill();
			toggleButtonUp.addChild(toggleBackgroundImage);

			const texture = toggleButtonUp.generateTexture();
			return texture;
		}
		return DifficultySelectionModal;
	});

